function FormataCodBanco(valor: string | undefined): string {
    return !!valor ? valor.toString().padStart(3, '0') : '';
}

export default FormataCodBanco;